/**
 * Generated from syncly-creator-spec/open-api/campaign.openapi.yaml by scripts/openapi-converter.
 * Do not edit this file directly.
 */

import { socialApiClient } from '@/shared/api-client/social-api-client';
import z from 'zod';
import {
  campaignCreatorListResponseSchema,
  campaignPlatformSchema,
} from '../campaign-schema';

export const listPendingCreatorsPathSchema = z.object({
  campaignId: z.string(),
});

export const listPendingCreatorsQuerySchema = z.object({
  platform: campaignPlatformSchema.optional(),
  name: z.string().optional(),
  label: z.string().optional(),
  page: z.number().int().default(1),
  limit: z.number().int().default(20),
});

export const listPendingCreatorsOperationResponseSchema =
  campaignCreatorListResponseSchema;

export type ListPendingCreatorsInput = {
  path: z.input<typeof listPendingCreatorsPathSchema>;
  query?: z.input<typeof listPendingCreatorsQuerySchema>;
  signal?: AbortSignal;
};

export async function listPendingCreators({
  path,
  query,
  signal,
}: ListPendingCreatorsInput): Promise<
  z.infer<typeof listPendingCreatorsOperationResponseSchema>
> {
  const parsedPath = listPendingCreatorsPathSchema.parse(path);
  const parsedQuery = listPendingCreatorsQuerySchema.parse(query ?? {});

  const response = await socialApiClient.get(
    `campaigns/${parsedPath.campaignId}/pending_creators`,
    {
      signal,
      searchParams: parsedQuery,
    },
  );
  return listPendingCreatorsOperationResponseSchema.parse(
    await response.json(),
  );
}
